export default __webpack_public_path__ + "static/media/J004-664X830.1d04baba.jpg";